import type { SVGProps } from 'react';
const SvgPlayDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#play_disabled_svg__a)">
      <path
        fill="currentColor"
        d="M8 5.19V5l11 7-2.55 1.63L8 5.19Zm12 14.54-5.11-5.11L8 7.73 4.27 4 3 5.27l5 5V19l5.33-3.4 5.4 5.4L20 19.73Z"
      />
    </g>
    <defs>
      <clipPath id="play_disabled_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlayDisabled;
